export default {
    'byFinancialForm.form.employees': 'Employees',
    'byFinancialForm.form.documents': 'Documents',
    'byFinancialForm.form.deduction': '%Deduction',
    'byFinancialForm.form.situation': 'Situation',
    'byFinancialForm.form.situation.open': 'Open',
    'byFinancialForm.form.situation.settled': 'Settled',
    'byFinancialForm.form.filterByDate': 'Filter by Date from',
    'byFinancialForm.form.filterByDate.emission': 'Emission',
    'byFinancialForm.form.filterByDate.dueDate': 'Due Date',
    'byFinancialForm.form.filterByDate.receipt': 'Receipt',
  };
  